<template>
  <svg :viewBox="`0 0 ${size} ${size * .72}`" :style="{width: size + 'px'}">
    <path :d="arc(Math.PI, 2 * Math.PI)" fill="none" stroke="var(--sd-line-2)" stroke-width="13" stroke-linecap="round" />
    <path :d="arc(Math.PI, Math.max(Math.PI + .02, Math.PI + rate / 100 * Math.PI))" fill="none" :stroke="color" stroke-width="13" stroke-linecap="round" />
    <text :x="cx" :y="cy - 8" text-anchor="middle" font-size="27" font-weight="800" fill="var(--sd-ink)">{{ pctS(rate) }}</text>
  </svg>
</template>
<script>
import { pctS } from '../../lib/format.js'
export default {
  name: 'SdGauge',
  props: { rate: { type: Number, default: 0 }, size: { type: Number, default: 150 } },
  computed: {
    cx() { return this.size / 2 }, cy() { return this.size / 2 + 8 }, r() { return 56 },
    color() { return this.rate >= 60 ? 'var(--sd-good)' : this.rate >= 35 ? 'var(--sd-warn)' : 'var(--sd-crit)' },
  },
  methods: {
    pctS,
    arc(a0, a1) { const P = (a) => [this.cx + this.r * Math.cos(a), this.cy + this.r * Math.sin(a)]; const [x0, y0] = P(a0), [x1, y1] = P(a1); return `M${x0},${y0} A${this.r},${this.r} 0 ${(a1 - a0) > Math.PI ? 1 : 0} 1 ${x1},${y1}` },
  },
}
</script>
